/* HMX V53 FROZEN PROOF — lifetime Gear With Love social proof + review-section jump, loaded after the frozen top owner. */
(function(){
'use strict';
if(window.__HMX_V53_FROZEN_PROOF__)return;
window.__HMX_V53_FROZEN_PROOF__=true;
var D=document;
function visible(n){if(!n)return false;var s=getComputedStyle(n);return s.display!=='none'&&s.visibility!=='hidden'&&n.getClientRects().length>0;}
function info(){return D.querySelector('#MainContent .main-product__info-container,#MainContent .product__info-container,#MainContent [data-hmx-wallet-v2] .hmx-v2__buy-panel');}
function storyTarget(){
  var main=info();
  var sels=['#v53-reviews','#MainContent [data-hmx-v52-customer-stories]','#MainContent [id*="wallet_testimonials"]','#MainContent [id*="testimonials"]','#MainContent [id*="review_grid"]','#MainContent [id*="review-grid"]','#MainContent .hmx-v2__reviews','#MainContent [class*="review-grid"]','#MainContent .testimonial-card','#MainContent .pp-review-block'];
  for(var i=0;i<sels.length;i++){
    var a=D.querySelectorAll(sels[i]);
    for(var j=0;j<a.length;j++){
      if(main&&(a[j]===main||main.contains(a[j])))continue;
      var n=a[j].closest('.shopify-section')||a[j];
      if(main&&(n===main||main.contains(n)))continue;
      if(visible(n)||a[j].id==='v53-reviews')return n;
    }
  }
  return null;
}
function row(canGo){
  return '<span class="hmx-v53-proof-stars" aria-hidden="true">★★★★★</span><strong class="hmx-v53-proof-rating">5.0 Rating</strong><span class="hmx-v53-proof-sep" aria-hidden="true">·</span><strong class="hmx-v53-proof-orders">30K+ Orders</strong>'+(canGo?'<span class="hmx-v53-proof-sep" aria-hidden="true">·</span><span class="hmx-v53-proof-link">See Reviews</span>':'');
}
function wire(node,target){
  if(!node)return;
  if(!target){node.classList.remove('is-clickable');node.removeAttribute('role');node.removeAttribute('tabindex');return;}
  node.classList.add('is-clickable');node.setAttribute('role','button');node.tabIndex=0;
  if(node.dataset.hmxV53ProofWired==='1')return;
  node.dataset.hmxV53ProofWired='1';
  var go=function(){target.scrollIntoView({behavior:'smooth',block:'start'});};
  node.addEventListener('click',go);
  node.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();go();}});
}
function apply(){
  if(location.pathname.indexOf('/products/')===-1)return;
  var target=storyTarget(),canGo=Boolean(target);
  var wallet=D.querySelector('#MainContent .v53-ratingproof');
  if(wallet){
    wallet.innerHTML=row(canGo);
    wallet.setAttribute('aria-label',canGo?'5.0 rating. Over 30,000 lifetime Gear With Love orders. See reviews.':'5.0 rating. Over 30,000 lifetime Gear With Love orders.');
    wire(wallet,target);
  }
  D.querySelectorAll('#MainContent .hmx-r15-proof').forEach(function(p){
    p.innerHTML=row(canGo);
    p.setAttribute('aria-label',canGo?'5.0 rating. Over 30,000 lifetime Gear With Love orders. See reviews.':'5.0 rating. Over 30,000 lifetime Gear With Love orders.');
    wire(p,target);
  });
}
if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',apply,{once:true});else apply();
D.addEventListener('shopify:section:load',function(){setTimeout(apply,0);});
})();